import React, { useEffect, useState } from "react";

import {
  Select,
  Accordion,
  Spinner,
  Button,
  useDisclosure,
} from "@chakra-ui/react";
import FilesTabAccordionItem from "../../../components/FilesTabAccordionItem/FilesTabAccordionItem";
import { Select as ReactSelect } from "chakra-react-select";
import GetSupplierChanges from "services/SupplierChangesService";
import getSupplierChangesDates from "services/GetSupplierChangesDates";
import formatDate from "utils/utils";

import summary_blue_icon from "../../../assets/images/icons/summary_icon/summary_blue_icon.png";
import SummaryDrawer from "components/SummaryDrawer/SummaryDrawer";

import data_not_found_blue_icon from "../../../assets/images/icons/general_icons/data_not_found_blue_icon.png";
import { getPdfHeadings } from "components/pdf/pdfUtils";
import ChangesDrawer from "./ChangesDrawer";

export default function FilesTab({ supplier_id }) {
  // use states
  const [changesDateList, setChangesDateList] = useState(null);
  const [supplierChangesDetails, setSupplierChangesDetails] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [supplierChangesSummary, setSupplierChangesSummary] = useState("");

  const [loadingDates, setLoadingDates] = useState(true);
  const [loadingFiles, setLoadingFiles] = useState(true);
  const [changes, setChanges] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [headings, setHeadings] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [selectPage, setSelectPage] = useState(null);
  const [fileUrl, setFileUrl] = useState("");

  const handleFetchTableOfContent = async () => {
    if (fileUrl) {
      try {
        const headingsData = await getPdfHeadings(fileUrl);
        setHeadings(headingsData);
      } catch (error) {
        console.error("Error comparing PDFs:", error);
      }
    } else {
      console.warn("Please upload both PDF files.");
      setHeadings([]);
    }
  };

  useEffect(() => {
    handleFetchTableOfContent();
  }, [fileUrl]);

  useEffect(() => {
    const params = {
      supplier_id: supplier_id,
    };

    const callGetSupplierChangesDate = async () => {
      setLoadingDates(true);
      const supplier_changes_dates_response = await getSupplierChangesDates(
        params
      );
      setChangesDateList(supplier_changes_dates_response.data);
      setSelectedDate(supplier_changes_dates_response.data[0]);
      setLoadingDates(false);
      setSupplierChangesDetails("");
      setSupplierChangesSummary("");
    };

    callGetSupplierChangesDate();
  }, [supplier_id]);

  useEffect(() => {
    if (!selectedDate) {
      setLoadingFiles(false);
      return;
    }

    const params = {
      supplier_id: supplier_id,
      supplier_changes_date: selectedDate,
      page_size: -1,
    };

    const getSupplierFilesChanges = async () => {
      if (!selectedDate) {
        setLoadingFiles(false);
        return;
      }

      setFileUrl("");

      setLoadingFiles(true);

      try {
        const supplier_changes_response = await GetSupplierChanges(params);
        setSupplierChangesDetails(supplier_changes_response?.data.data);

        setFileUrl(
          supplier_changes_response?.data.data?.supplier_changes_files_path[0]
        );

        if (supplierChangesDetails?.supplier_changes_summary?.length > 0) {
          setSupplierChangesSummary(
            supplierChangesDetails?.supplier_changes_summary[0]
          );
        }
      } catch (error) {
        console.error("Error fetching supplier changes:", error);
      } finally {
        setLoadingFiles(false);
      }
    };

    getSupplierFilesChanges();
  }, [selectedDate, supplier_id]);
  const handleSelect = (selected) => {
    setSelectPage(selected);
    setPageNumber(selected.pageNumber);
  };

  return (
    <div className="">
      <SummaryDrawer
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        summaryText={supplierChangesSummary}
      />
      <div className="flex">
        {(loadingDates || changesDateList?.length !== 0) && (
          <p className="w-48 label">
            <b>Dates</b>
          </p>
        )}
        {headings.length >= 1 && (
          <p className="label">
            <b>Table of Content</b>
          </p>
        )}
      </div>
      <div className="flex justify-between w-full">
        <div className="flex gap-1">
          {loadingDates ? (
            <div className="flex flex-col justify-center w-full h-10">
              <Spinner size="md" />
            </div>
          ) : !changesDateList.length ? (
            <>
              <div></div>
            </>
          ) : (
            <div className="w-48 mb-5 ">
              <Select
                size="lg"
                variant={"outlineCustom"}
                onChange={(e) => setSelectedDate(e.target.value)}
                value={selectedDate}
              >
                {changesDateList?.map((date) => {
                  return <option value={date}>{formatDate(date)}</option>;
                })}
              </Select>
            </div>
          )}
          {supplierChangesDetails?.supplier_changes_files_name?.length > 0 &&
            headings.length >= 1 && (
              <div className="w-96">
                <ReactSelect
                  size="lg"
                  isSearchable
                  onChange={handleSelect}
                  value={selectPage}
                  options={headings}
                />
              </div>
            )}
        </div>

        {!loadingFiles &&
          !loadingDates &&
          supplierChangesDetails?.supplier_changes_files_name?.length > 0 && (
            <div className="flex">
              {/* {changes.length >= 1 && (
                <ChangesDrawer
                  changes={changes}
                  setPageNumber={setPageNumber}
                />
              )} */}

              <Button variant="ghost" onClick={onOpen}>
                <div className="flex flex-row gap-2 ">
                  <div className="h-[20px] w-[20px] ">
                    <img className="" src={summary_blue_icon} />
                  </div>
                  <p className="hidden secondary-text sm:block ">
                    View Summary
                  </p>
                </div>
              </Button>
            </div>
          )}
      </div>
      {loadingFiles || loadingDates ? (
        <div className="w-full h-[30vw]  flex flex-row justify-center">
          <div className="my-auto">
            <Spinner size="lg" />
          </div>
        </div>
      ) : supplierChangesDetails?.length === 0 ? (
        <div className="w-full h-[30vw]  flex flex-row justify-center">
          <div className="flex flex-row justify-center gap-2 my-auto ">
            <img src={data_not_found_blue_icon} />
            <p>No data found!</p>
          </div>
        </div>
      ) : (
        <Accordion variant="custom" allowMultiple defaultIndex={[0]}>
          {supplierChangesDetails?.supplier_changes_files_name?.map(
            (data, index) => {
              return (
                <FilesTabAccordionItem
                  file_name={data}
                  pageNumber={pageNumber}
                  file_changes_data={
                    supplierChangesDetails?.supplier_changes_files_data[index]
                  }
                  onClickFn={() => {
                    setSupplierChangesSummary(
                      supplierChangesDetails?.supplier_changes_summary[index]
                    );
                    setChanges(
                      supplierChangesDetails?.supplier_changes_files_data[index]
                    );
                  }}
                  fileLink1={
                    supplierChangesDetails?.supplier_changes_files_two_path[
                      index
                    ]
                  }
                  fileLink2={
                    supplierChangesDetails?.supplier_changes_files_path[index]
                  }
                  setFileUrl={setFileUrl}
                />
              );
            }
          )}
        </Accordion>
      )}
    </div>
  );
}
